'use client';

import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import type { ResponseSnowPlow } from '@hc-frontend/third-party-snowplow';
import Cookies from 'js-cookie';

import type { TrackingSessionRepository } from '../../domain';

export function snowplowTrackingRepositoryAdapterFactory(
  tracker: ResponseSnowPlow['tracker'],
): TrackingSessionRepository {
  return {
    getUserId: async () => {
      try {
        const userId = tracker.getDomainUserInfo()[1];

        Cookies.set('domainUser', userId);

        return createSuccessOperationResult(userId);
      } catch (e) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToGetDomainUserId',

              rootCause: e as Error,
            },
          ],
        });
      }
    },
    getSessionId: async () => {
      try {
        const sessionId = tracker.getDomainUserInfo()[6];

        Cookies.set('domainSession', sessionId);

        return createSuccessOperationResult(sessionId);
      } catch (e) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failToGetDomainSessionId',

              rootCause: e as Error,
            },
          ],
        });
      }
    },
  };
}
